import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './Sections.module.css';
import featureImg1 from '../Images/land-finding-img1.png';
import featureImg2 from '../Images/land-finding-img2.png';
import featureImg3 from '../Images/land-finding-img3.png';
function FeatureSection() {
  return (
    <div className={css.featureSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.featureInfo}>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg1} alt="" />
            </div>
            <h3>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.structuralTitle" />
            </h3>
            <p>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.structuralDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg2} alt="" style={{ objectFit: 'contain' }} />
            </div>
            <h3>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.developmentTitle" />
            </h3>
            <p>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.developmentDescription" />
            </p>
          </div>
          <div className={css.featureBlock}>
            <div className={css.featureImg}>
              <img src={featureImg3} alt="" style={{ objectFit: 'contain' }} />
            </div>
            <h3>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.propertyTitle" />
            </h3>
            <p>
              <FormattedMessage id="InsuranceAndFinancePage.FeatureSection.propertyDescription" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeatureSection;
